<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">理财系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>挖矿宝</el-breadcrumb-item>
            <el-breadcrumb-item>新币挖矿</el-breadcrumb-item>
        </el-breadcrumb>

        <el-autocomplete class="inline-input" style="width: 200px"
                         v-model="queryParams.coin"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入币种">
            <i class="el-icon-close el-input__icon" slot="suffix"
               @click="cleanSearchCoin" style="cursor:pointer;">
            </i>
        </el-autocomplete>
        <el-select v-model="queryParams.put" placeholder="请选择">
            <el-option value="" label="所有"></el-option>
            <el-option value="PUT" label="上架"></el-option>
            <el-option value="DOWN" label="下架"></el-option>
        </el-select>
        <el-button type="primary" @click="searchData" style="margin: 20px 0">搜 索</el-button>
        <el-button type="danger" @click="addNewCoinDialog" style="margin: 20px 20px">增 加</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" fixed="left" label="ID"></el-table-column>
            <el-table-column prop="coin" label="挖矿币种"></el-table-column>
            <el-table-column prop="priority" label="优先级"></el-table-column>
            <el-table-column prop="cycle" label="挖矿周期"></el-table-column>
            <el-table-column prop="totalPeople" label="参与人数"></el-table-column>
            <el-table-column prop="totalReward" label="挖矿奖励总量"></el-table-column>
            <el-table-column prop="beginTime" label="挖矿开始时间">
                <template slot-scope="scope">
                    <span>{{scope.row.beginTime | moment}}</span>
                </template>
            </el-table-column>

            <el-table-column prop="putStatus" label="上/下架" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.putStatus==0?true:false" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterStatus(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateDialog(scope.row)">编辑</el-button>
                    <el-button type="primary" @click="poolPage(scope.row.id)">管理配置</el-button>
                    <el-button type="danger" @click="deleteNewCoin(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item label="挖矿币种：" prop="coin" style="padding-top: 20px">
                    <el-autocomplete class="inline-input" style="width: 500px"
                                     v-model="addData.coin"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanAddCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="优先级：" prop="priority" style="padding-top: 20px">
                    <el-input v-model="addData.priority" placeholder="优先级(正整数：0＜X≤999999999)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="挖矿周期：" prop="priority" style="padding-top: 20px">
                    <el-input v-model="addData.cycle" placeholder="优先级(正整数：0＜X≤999999999)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="挖矿开始时间：" prop="beginTime" style="padding-top: 20px">
                    <el-date-picker
                            v-model="addData.beginTime"
                            type="datetime"
                            value-format="timestamp"
                            placeholder="选择挖矿开始时间">
                    </el-date-picker>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addNewCoin">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'NewCoin',
        data() {
            return {
                dataList: [],
                total: 0,
                coinTypes: [],
                queryParams: {
                    coin: "",
                    put: "",
                    page: 1,
                    size: 10,
                },
                title: "",
                dialogVisible: false,
                loading: false,
                addData: {
                    id: "",
                    coin: "",
                    priority: "",
                    cycle: "",
                    beginTime: ""
                },
                addRules: {
                    "coin": [{required: true, message: "请输入挖矿币种"}],
                    "priority": [{required: true, message: "请输优先级"}],
                    "cycle": [{required: true, message: "请输入挖矿周期"}],
                    "beginTime": [{required: true, message: "请输入挖矿开始时间"}],
                },
            }
        },
        methods: {
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getNewCoinList() {
                this.queryParams.put = null;
                api.getNewCoinPage(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            searchData() {
                this.queryParams.page = 1;
                this.getNewCoinList();
            },
            addNewCoinDialog() {
                this.title = "新增";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.title = "修改";
                this.addData = {
                    id: row.id,
                    coin: row.coin,
                    priority: row.priority,
                    cycle: row.cycle,
                    beginTime: row.beginTime
                };
                this.dialogVisible = true;
            },
            poolPage(id) {
                this.$router.push({
                    path: '/home/mining/newCoinDetail',
                    query: {
                        id: id
                    }
                });
            },
            addNewCoin() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.addOrUpdateNewCoin(this.addData).then(({data}) => {
                            this.$message.success('操作成功!');
                            this.loading = false;
                            this.dialogVisible = false;
                            this.getNewCoinList();
                        });
                        setTimeout(()=>{
                            this.loading = false;
                        },1000);
                    }
                });
            },
            deleteNewCoin(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteNewCoin({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getNewCoinList();
                    });
                }).catch(() => {
                });
            },
            alterStatus(id, status) {
                this.$confirm(status ? '确认上架吗？' : '确认下架吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateNewCoinState({id: id, put: status ? 'PUT' : 'DOWN'}).then(() => {
                        this.$message.success('操作成功');
                        this.getNewCoinList();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getNewCoinList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getNewCoinList();
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coin = '';
            },
            cleanAddCoin() {
                this.addData.coin = '';
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.title = "";
                this.addData = {
                    id: "",
                    coin: "",
                    priority: "",
                    cycle: "",
                    beginTime: ""
                };
            }
        },
        created() {
            this.getAllSupportCoin();
            this.getNewCoinList();
        }
    };
</script>

<style lang="less" scoped>

</style>
